import React from "react";
import {RangeOptions} from "../lavoratore/RangeOptions";
import {UseFormReturn} from "react-hook-form/dist/types";
import {MonitorWfForm} from "../../pages/presenze/monitorWF/monitorWF";

interface LavoratoreFilterProps {
    // isValid?: boolean,
    hook: UseFormReturn<MonitorWfForm, any, undefined>,
}

const IntervalloSelectFilter: React.FC<LavoratoreFilterProps> = ({/*isValid,*/ hook}) => {

    return <>
        <fieldset className="border border-[#2ECC71] pb-2 px-2 rounded-lg shadow w-auto">
            <legend className="px-2 text-[#2ECC71]">Periodo</legend>
            <div>
                <div className="flex flex-row flex-wrap max-sm:flex max-sm:flex-col divide-y divide-solid">
                    <div className="w-full max-sm:w-full py-2">
                        <RangeOptions<MonitorWfForm> {...hook}
                                                     enabled={true}
                                                     radioGroupName="periodo"
                                                     dataDaName={"intervallo.startDate"}
                                                     dataDa={hook.getValues('intervallo.startDate')}
                                                     dataAName={'intervallo.endDate'}
                                                     dataA={hook.getValues('intervallo.endDate')}
                        />
                    </div>
                </div>
                {/* BUTTON */}
                {/*<div className="text-right">
                    <button type="submit" disabled={!isValid}
                            className="ml-2 inline-flex justify-center p-1.5 sm:p-2 md:py-2 md:px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                                        hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50">
                        Applica & cerca
                        <MagnifyingGlassIcon className="ml-2 -mr-0.5 h-5 w-5"/>
                    </button>
                </div>*/}
            </div>
        </fieldset>
    </>
}

export default IntervalloSelectFilter;